// Get current state of opened main menu
export const getMainMenuState = state => state.mainMenu;
